import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';

import {
  StockCountHistoryListContent,
  StockCountHistorySearchCriteria,
  StockCountHistoryViewResponse
} from '../model/stock-count-history.model';

@Injectable({
  providedIn: 'root'
})
export class StockCountHistoryService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockCountHistory;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStockCountHistoryList(criteria: StockCountHistorySearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.list);

    return this.http.get<Pagination<StockCountHistoryListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStockCountHistory(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { docNo });

    return this.http.get<StockCountHistoryViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
